define('modules/T1App/edit/meta/main',["jQuery", "T1", "T1Module", "models/t1App"], function ($, T1, T1Module) {
  "use strict";

  var instance;
  if (instance === undefined) {
    instance = new T1Module({
      name: "T1App/edit/meta",
      viewCfgs: {
        meta: {}
      },
      defaultView: "meta"
    });
  }
  return instance;
});
